<template>
  <div class="content_box">
    <div style=" font-size: 16px;">银行卡绑定</div>
    <div v-show="addCardShow">
      <div style="display: flex;justify-content: center;">
        <div class="step_box clearfix">
          <div class="f_l" style="width:35%">
            <div class="step_item">
              <div class="f_l step_ing">
                <div class="step_round">1</div>
                <div class="step_title">填写账户信息</div>
              </div>
              <div style="flex:1">
                <div class="step_line"></div>
              </div>
            </div>
          </div>
          <div class="f_l" style="width:35%">
            <div class="step_item">
              <div class="f_l">
                <div class="step_round">2</div>
                <div class="step_title">激活账户</div>
              </div>
              <div style="flex:1">
                <div class="step_line"></div>
              </div>
            </div>
          </div>
          <div class="f_l" style="width:20%">
            <div class="step_item">
              <div class="f_l">
                <div class="step_round">3</div>
                <div class="step_title">完成</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="from_box">
          <el-form ref="form" :model="formMsg" :rules="rules" label-width="120px">
            <el-form-item label="银行户名：" style="margin-bottom:20px"><span style="width:100%">{{customerName}}</span></el-form-item>
            <el-form-item label="银行卡号：" prop="cardNum" style="margin-bottom:20px">
                <!-- :readonly="isEdit" -->
              <el-input
                v-model="formMsg.cardNum"
                clearable
                placeholder="请输入银行卡号"
                style="width:435px"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行：" prop="selectVal" style="margin-bottom:20px">
              <el-select
                v-model="formMsg.selectVal"
                filterable
                clearable
                placeholder="请选择开户银行"
                style="width:435px"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="item.bankName + '_' + index"
                  :label="item.bankName"
                  :value="item.bankName"
                >
                <img :src="item.imgSrc" alt="" style="float: left;width: 26px;height: 26px;margin-top: 4px;margin-right: 5px;">
                <span style="float: left">{{ item.bankName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码：" prop="phoneNum" style="margin-bottom:20px">
              <el-input
                placeholder="请输入联系人手机号码"
                clearable
                v-model.number="formMsg.phoneNum"
                class="input-with-select"
                style="width:435px"
              >
                <!-- <el-select
                  v-model="formMsg.area"
                  slot="prepend"
                  placeholder="请选择"
                  style="width:130px"
                >
                  <el-option label="大陆+86" value="1"></el-option>
                </el-select> -->
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit('form')" :disabled="flag">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <active-card v-show="activeCardShow" :bankCard="formMsg.cardNum" :bankCardId="bankCardId" @getAccountId="getAccountId" @edit-account="editAccount" ref="activeCard"></active-card>
    <Complete v-show="completeShow" ref="complete"></Complete>
    <div class="tips_box">
      <div style="margin-bottom:12px">说明</div>
      <div style="font-size: 14px;color: rgba(0,0,0,0.45)">完成银行卡绑定后才能进行业务操作</div>
    </div>
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
import bankArr from "@/utils/bank.js";
import ActiveCard from "@/pages/account/activeCard.vue";
import Complete from "@/pages/account/complete.vue";
import getCheckPhone from '@/common/js/checkPhone.js';

export default {
  data() {
    var checkCardNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("银行卡号不能为空"));
      }
      if (isNaN(value)) {
        callback(new Error("请输入数字值"));
      } else {
        var newVal = value + "";
        if (newVal.length > 20 || newVal.length < 3) {
          callback(new Error("请输入3-20位数字"));
        } else {
          callback();
        }
      }
    };
      // 手机号校验
    const checkPhone = getCheckPhone();

    return {
      customerName: "",
      formMsg: {
        cardNum: "",
        selectVal: "",
        phoneNum: "",
        area: "1"
      },
      isEdit: false,
      rules: {
        cardNum: [{ required: true, validator: checkCardNum, trigger: "blur" }],
        selectVal: [
          { required: true, message: "请选择开户银行", trigger: "change" }
        ],
        phoneNum: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ]
      },
      options: [],
      flag: false,
      addCardShow:true,
      activeCardShow:false,
      completeShow:false,
      bankCardId:"",
      accountId:"",
    };
  },
  mounted() {
    let bankCardInfo = sessionStorage.getItem('bankCardInfo')
    if(bankCardInfo){
      bankCardInfo = JSON.parse(bankCardInfo)
      this.isEdit = true
      this.formMsg = {
        cardNum: bankCardInfo.fullBankCardNumber,
        selectVal: bankCardInfo.bankName,
        phoneNum: bankCardInfo.phone || '',
        area: "1"
      }
      this.bankCardId = bankCardInfo.id
      this.addCardShow = false;
      this.activeCardShow = true;
      this.completeShow = false;
    }
    this.queryBankAccount();
    this.queryBankList();
  },
  components:{
    ActiveCard,
    Complete
  },
  methods: {
    editAccount () {
      this.addCardShow = true;
      this.activeCardShow = false;
      this.completeShow = false;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.flag = true;
          this.bankCardActivate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    queryBankAccount() {
      fetchPost("/saas/bankAccountBind/queryBankAccount", {}).then(res => {
        this.customerName = res.customerName;
      });
    },
    queryBankList() {
      fetchPost("/saas/bankAccountBind/v2/queryBankList", {}).then(res => {
        if (res) {
          for(var i = 0 ; i<res.length;i++){
             res[i].imgSrc = "/bankIcon/tongyong.png";
              for(var j = 0 ; j<bankArr.length;j++){
                if(res[i].bankName == bankArr[j].name){
                    res[i].imgSrc = bankArr[j].imgSrc;
                }
              }
           }
          this.options = res;
          if (this.formMsg.selectVal) {
            const arr = this.options.filter(ele => ele.bankName === this.formMsg.selectVal)
            if (!arr || (arr && arr.length !== 1)) {
              this.formMsg.selectVal = ''
            }
          }
        }
      });
    },
    bankCardActivate() {
      var temp = this.options.find(
        item => item.bankName == this.formMsg.selectVal
      );
      var data = {
        bankCard: this.formMsg.cardNum,
        bankName: temp.bankName,
        bankCode: temp.bankCode,
        sponlineBankAccount: temp.sponlineBankAccount,
        bankAccount: this.customerName,
        phone: this.formMsg.phoneNum
      };
      fetchPost("/saas/bankAccountBind/v2/bankCardActivate", data)
        .then(res => {
          if (res) {
            this.flag = false;
            // sessionStorage.setItem("bankCard", res);
            this.bankCardId = res;
            this.addCardShow = false;
            this.activeCardShow = true;
            //this.$router.push("/manage/ActiveCard");
          }
        })
        .catch(res => {
          this.flag = false;
        });
    },
    getAccountId(accountId){
        this.addCardShow = false;
        this.activeCardShow = false;
        this.completeShow = true;
        this.$refs.complete.getBankCardInfo(accountId)
    },
  }
};
</script>

<style lang="less" scoped>
.from_box /deep/ .el-form-item__content{
  width: 200px !important;
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}

.clearfix:after {
  *zoom: 1;
  /*针对IE6/IE7*/
}
.f_l {
  float: left;
}
.from_box {
  width: 760px;
  margin-bottom: 90px !important;
}
.from_box .el-button {
  background: #dc1e32;
  color: #fff;
}
.content_box {
  color: #000;
  padding: 24px 32px !important;
  font-family: PingFangSC-Medium;
  .step_box {
    width: 800px;
    margin-top: 30px !important;
    margin-bottom: 45px !important;
    .step_item {
      width: 100%;
      display: flex;
      .step_round {
        float: left;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-right: 8px !important;
        border-radius: 50%;
      }
      .step_title {
        float: left;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 32px;
      }
      .step_line {
        margin: 0 8px !important;
        margin-top: 15px !important;
        height: 1px;
        background: rgba(0, 0, 0, 0.15);
      }
      .step_ing {
        .step_round {
          background: #f6c7cc;
          color: #dc1e32;
          border: none;
        }
        .step_title {
          color: #000;
        }
      }
    }
  }
  .tips_box {
    padding-top: 24px !important;
    border-top: 1px solid #e9e9e9;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>